import angular from 'angular'

const VINE_RE = /^https:\/\/vine\.co\/v\/.+\/embed\/simple/i
const VIMEO_RE = /^https:\/\/player\.vimeo\.com\/video\/.+/i
const GLEAM_RE = /\/gallery-vote-frame\/[^/]+$|\/webpack\/vote-frame\/mock\.html\?id=[^/]+$/i
const YOUTUBE_RE = /^https:\/\/www\.youtube\.com\/embed\/.+[?&]enablejsapi=1/i
const SOUNDCLOUD_RE = /^https:\/\/w\.soundcloud\.com\/player\/.+/i

angular
  .module('ggs.frame')
  .factory('frameHost', frameHostProvider)

function frameHostProvider() {
  return {
    isVine(iframeSrc) {
      return VINE_RE.test(iframeSrc)
    },
    isVimeo(iframeSrc) {
      return VIMEO_RE.test(iframeSrc)
    },
    isGleam(iframeSrc) {
      return GLEAM_RE.test(iframeSrc)
    },
    isYoutube(iframeSrc) {
      return YOUTUBE_RE.test(iframeSrc)
    },
    isSoundcloud(iframeSrc) {
      return SOUNDCLOUD_RE.test(iframeSrc)
    }
  }
}
